/* Publish by EComposer at 2026-10-09 15:54:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ns7leqp3il"]=  window.__ectimmers["ecom-ns7leqp3il"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ns7leqp3il').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ns7leqp3il', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ow7lhw07hp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ow7lhw07hp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0rtivniecdwj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0rtivniecdwj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32cnjwi2q48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32cnjwi2q48', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lkzuvr0i88').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lkzuvr0i88', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htfendx8nd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htfendx8nd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5iw4x5ebkro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5iw4x5ebkro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1h84r86a2op').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1h84r86a2op', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yw61u958zt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yw61u958zt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1m6x3zvp3al').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1m6x3zvp3al', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6bf61anhnsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bf61anhnsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x2pkkfp8xw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x2pkkfp8xw', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2s18igge6e8"]=  window.__ectimmers["ecom-2s18igge6e8"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-2s18igge6e8"]["lbcpc2byv"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2s18igge6e8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2s18igge6e8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6cweti5mbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6cweti5mbr', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}